import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePersona } from '@/hooks/usePersona';

/**
 * Gate a route on the resolved persona key. Admins always pass through so
 * support / QA can preview a persona dashboard without remapping their
 * employee_code.
 */
const PersonaRoute = ({ persona, children }) => {
  const { persona: current, loading } = usePersona();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-border border-t-primary" />
      </div>
    );
  }

  if (current) {
    if (current !== persona) return <Navigate to="/403" replace />;
    return children;
  }

  return <Navigate to="/403" replace />;
};

export default PersonaRoute;
